module.exports = __webpack_public_path__ + "static/3-4e782fb5245a6641a234b5f97d166059.jpg";